import { RangePropertiesProvider } from './panel-properties';

export const PropertiesPanelExtension = {
    __init__: [ 'rangePropertiesProvider' ],
    rangePropertiesProvider: [ 'type', RangePropertiesProvider ]
};